import CalendarMonthSurfaceItemBase from './itemTemplates/CalendarMonthSurfaceItem.base';
import { getStyles } from './itemTemplates/CalendarMonthSurfaceItem.styles';
import renderCharmWrapperMonthItem from './RenderCharmWrapperMonthItem';
import { observer } from 'mobx-react-lite';
import { styled } from '@fluentui/react/lib/Utilities';
import { CharmInfo, getCharmForId } from 'owa-calendar-charms-store';
import { getCalendarEventItemSubjectText } from 'owa-calendar-event-attributes';
import { CalendarItemTypeConstants } from 'owa-calendar-surface-dategrid';
import { formatShortHourOrTime, isAllDayEvent } from 'owa-datetime';
import * as React from 'react';
import {
    hasIcon,
    renderIconWrapper,
} from 'owa-calendar-surface-dategrid/lib/surfaceItems/CalendarSurfaceItemComponentRenderer';
import type {
    CalendarMonthSurfaceItemContentProps,
    CalendarMonthSurfaceItemProps,
    CalendarMonthSurfaceItemStyleProps,
    CalendarMonthSurfaceItemStyles,
} from './itemTemplates/CalendarMonthSurfaceItem.types';

import styles from './CalendarMonthSurfaceItem.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

const DefaultCalendarMonthSurfaceItem = observer(function DefaultCalendarMonthSurfaceItem(
    props: CalendarMonthSurfaceItemProps
) {
    const renderContent = (contentProps: CalendarMonthSurfaceItemContentProps) => {
        const { item, colorScheme, charmId } = props;
        const charm = getCharmForId(charmId) as CharmInfo;

        const shouldShowEventStartTime = props.shouldShowEventStartTime ?? true;

        const wrapperClassName = classNames(
            styles.monthItemWrapper,
            {
                [styles.itemIsCancelled]: item.ResponseType === 'Decline' || item.IsCancelled,
            },
            props.isSelectedDay && styles.isSelectedDay
        );

        // inner content of month surface item is aria-hidden so that we don't stop on it in scan mode,
        // since the outer wrapper has aria-label that reads all relevant info
        return (
            <div className={wrapperClassName} aria-hidden={true}>
                {shouldShowEventStartTime && !isAllDayEvent(item.Start, item.End) && (
                    <time className={styles.itemStartTime}>
                        {formatShortHourOrTime(item.Start)}
                    </time>
                )}
                {charm.IconId > 0 &&
                    item.CalendarItemType != CalendarItemTypeConstants.Exception && (
                        <i className={styles.charmWrapperPlaceholder}>
                            {renderCharmWrapperMonthItem(item, colorScheme, charmId)}
                        </i>
                    )}
                <div className={styles.itemSubject}>
                    <span>{getCalendarEventItemSubjectText(item)}</span>
                    {contentProps.isMultiDayItem &&
                        renderIconWrapper(item, false, undefined /*item state*/, styles)}
                </div>
                {hasIcon(item, null) && (
                    <div className={styles.iconContainer}>
                        {!contentProps.isMultiDayItem &&
                            renderIconWrapper(item, false, undefined /*item state */, styles)}
                    </div>
                )}
            </div>
        );
    };
    return <CalendarMonthSurfaceItemBase {...props} onRender={renderContent} />;
});

const CalendarMonthSurfaceItem = styled<
    CalendarMonthSurfaceItemProps,
    CalendarMonthSurfaceItemStyleProps,
    CalendarMonthSurfaceItemStyles
>(DefaultCalendarMonthSurfaceItem, getStyles);
export default CalendarMonthSurfaceItem;
